
import { Card, CardActions, CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout'
import { Button } from '@progress/kendo-react-buttons'
import React from 'react'
import { Link } from 'react-router-dom'
import Scrollbars from 'react-custom-scrollbars-2'

export default function ErrorCard(props: ErrorProps) {
    return (
        <>
            <div className='error-card d-flex justify-content-center mt-5 mb-'>
                <img src='./images//Host_Images/Logo/banner.gif'></img>
            </div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-sm-9 col-12">
                        <Card type="error"            >

                            <CardBody>
                                <CardTitle><b>An unexpected error occurred!</b></CardTitle>
                                <CardTitle><h4>{props.message}</h4></CardTitle>

                                <Scrollbars autoHeight={true} autoHeightMin={'400px'} style={{ fontSize: '1.1rem', color: '#000' }}>
                                    {props.details}
                                </Scrollbars>

                            </CardBody>
                            <CardActions style={{ color: '#000' }}>
                                <span className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-primary">
                                    <a href='./'><Button themeColor='primary' size='large' icon='refresh'>Retry</Button></a>
                                </span>
                                <span className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-primary">
                                    <Link to='/signout'> <Button themeColor='secondary' size='large' icon='logout'>Sign out</Button></Link>
                                </span>
                            </CardActions>
                        </Card>
                    </div>
                </div>
            </div>
            <div className='m-1 mw-500px'>
            </div>
        </>
    )
}

export type ErrorProps = {
    message: string
    details: string
}